/* eslint-disable prefer-rest-params */
import Signal from '@getgo/signal';
function ParentPluginNode(parent) {
    this.parent = null;
    this._hasChild = false;
    this._children = [];
    this._treeVersion = -1;
    this.signals = Object.assign(this.signals || {}, {
        onAncestryChanged: new Signal(),
    });
    this.updateParent(parent);
}
ParentPluginNode.prototype._checkAncestry = function checkAncestry() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    let node = this;
    const treeVersion = node.root._treeVersion;
    if (node._treeVersion === treeVersion)
        return true;
    const nodeList = [];
    while (node) {
        nodeList.push(node);
        node = node.parent;
    }
    const root = nodeList.pop();
    while ((node = nodeList.pop())) {
        if (root !== node.root)
            continue;
        if (node._treeVersion !== treeVersion) {
            node.signals.onAncestryChanged.dispatch();
            node._treeVersion = treeVersion;
        }
    }
    return false;
};
ParentPluginNode.prototype.updateParent = function updateParent(p) {
    const parent = p || this.root;
    let node = parent;
    if (this === this.root)
        return;
    if (parent.root !== this.root) {
        throw new Error('Cannot switch node to other tree');
    }
    while (node) {
        if (node === this)
            throw new Error('Cycle detected: parent cannot be a descendant');
        node = node.parent;
    }
    if (this.parent) {
        const index = this.parent._children.indexOf(this);
        if (index > -1) {
            this.parent._children.splice(index, 1);
        }
    }
    this.parent = parent;
    this.parent._hasChild = true;
    this.parent._children.push(this);
    if (this._hasChild) {
        // Only change the tree version if this node is up to date
        // If this node is not up to date, none of its children are
        if (this.root._treeVersion === this._treeVersion) {
            this.root._treeVersion++;
        }
    }
    if (this._checkAncestry()) {
        // This node's tree version was up to date, but parent changed
        // We're a simple leaf node, manually notify of ancestry change
        this.signals.onAncestryChanged.dispatch();
    }
};
function ParentPluginRootNode() {
    this.parent = null;
    this._treeVersion = 0;
}
ParentPluginRootNode.prototype.updateParent = function updateParent() {
    return undefined;
};
function getParentPluginNodeMethodOverrides() {
    return {
        create: function create() {
            const args = [this];
            Array.prototype.push.apply(args, arguments);
            return create._super.apply(this, args);
        },
    };
}
export default {
    pluginName: 'parent',
    nodeInit: ParentPluginNode,
    nodeMethods: ParentPluginNode.prototype,
    getNodeMethodOverrides: getParentPluginNodeMethodOverrides,
    rootMethods: ParentPluginRootNode.prototype,
    rootInit: ParentPluginRootNode,
};
//# sourceMappingURL=parent.js.map